import { defineStore } from 'pinia'
import { computed, nextTick, ref } from 'vue'

export type Notification = {
  type: 'success' | 'error' | 'warning'
  message: string
}

export const _useNotificationStore = defineStore('notifications', {
  state: () => ({
    notification: undefined as Notification | undefined
  })
})

export const useNotification = () => {
  const closeTimeoutId = ref<number>()
  const store = _useNotificationStore()
  const notification = computed(() => store.notification)
  const cancelTimeouts = () => {
    clearTimeout(closeTimeoutId.value)
    closeTimeoutId.value = undefined
  }
  const closeNotification = () => {
    cancelTimeouts()
    store.notification = undefined
  }
  const push = (n: Notification, delayInMs: number = 4_000) => {
    if (store.notification) {
      store.notification = n
    } else {
      store.notification = undefined
      nextTick(() => (store.notification = n))
    }

    if (delayInMs >= 0) {
      closeTimeoutId.value = setTimeout(closeNotification, delayInMs)
    }
  }
  return { notification, push }
}
